import { ProcedureCodes } from '@core/domain/model/procedures/procedure-codes';

export enum NotificationTypes {
  PROCEDURE = 'PROCEDURE',
  CONTRACT = 'CONTRACT',
  INVOICE = 'INVOICE',
  DRAFT = 'DRAFT',
  MARKET = 'MARKET',
  ACCIONA_ENERGY = 'ACCIONA_ENERGY',
  USUARIOS = 'USUARIOS',
  ERROR_CRM_PROCEDURE = 'ERROR_CRM_PROCEDURE',
}

export enum HeaderNotification {
  INVOICES = 'INVOICES',
  PROCEDURES = 'PROCEDURES',
}

export enum NotificationCategories {
  ALL = 'ALL',
  URGENT = 'URGENT',
  ARCHIVED = 'ARCHIVED',
  ALERT = 'ALERT',
}

export type Notification = {
  id: number;
  title: string;
  type: NotificationTypes;
  description: string;
  date: string;
  crmCode: string | null;
  isRead: boolean;
  isUrgent: boolean;
  draftId: number | null;
  procedureTypeCode: ProcedureCodes | null;
};
